import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
//@ts-ignore
import type MarkdownPreviewer from '../components/markdown-previewer.vue'

export const LlMarkdownPreviewerProps = buildProps({
  value: {
    type: String,
    default: () => '',
  },
  showCatalog: {
    type: Boolean,
    default: false,
  },
} as const)

export type MarkdownPreviewerProps = ExtractPropTypes<
  typeof LlMarkdownPreviewerProps
>

export type MarkdownPreviewerInstance = InstanceType<typeof MarkdownPreviewer>
